import { render, staticRenderFns } from "./AddCredits.vue?vue&type=template&id=21dc7bd4&scoped=true&"
import script from "./AddCredits.vue?vue&type=script&lang=js&"
export * from "./AddCredits.vue?vue&type=script&lang=js&"
import style0 from "./AddCredits.vue?vue&type=style&index=0&id=21dc7bd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dc7bd4",
  null
  
)

export default component.exports